export const projectList = [
  {
    type : 'Project',
    name : 'Spring Fest Website',
    description : 'Developed the official website for Spring Fest IIT Kharagpur',
    card_desc: "Developed the official website for Spring Fest IITKGP. This is the first time I came across React and eventually learned it doing this project",
    p : 'Responsible for creating and managing the official websites of Spring Fest, IIT Kharagpur, as a part of an 11-member team. Developed the sponsors\' page, which is a fully responsive single-page application, and the mobile-only site of Spring Fest using the React framework with Redux interacting with a PHP API backend.',
    tags : ['React', 'Redux', 'Javascript'],
    tech : ['HTML', 'CSS', 'Javascript', 'React', 'Redux'],
    link : "https://www.springfest.in/",
    src : require('../assests/web_images/spring_fest.PNG')
  },
  {
    type : 'Project',
    name : 'RP Hall Website',
    description : 'The official website for RP Hall',
    card_desc : "A website made for the students of IIT KGP university. This website was made to improve the workflow of the admins and students.",
    p : 'A website made for the students of the RP Hall for easier workflow and providing timely notification. It has a complaint and a feedback portal where students can enter their responses. It also allows the adminstration to get access to student\'s data from one place which enable them to work more efficiently',
    tags : ['HTML', 'Django', 'Apache'],
    tech : ['HTML', 'CSS', 'Javascript', 'Django', 'Apache'],
    link : 'http://www.rphall.iitkgp.ac.in/',
    src : require('../assests/web_images/rp_hall.PNG')
  },
  {
    type : 'Project',
    name : 'Personal Website',
    description : 'Personal Website for Shibashis Das',
    card_desc : "Developed my personal website. Paid extra attention to design and aesthetics. Took inspiration from many websites",
    tags : ['HTML', 'React', 'Javascript'],
    tech : ['Web-dev', 'HTML', 'CSS', 'JavaScript', 'p5.js'],
    link : 'https://eiden0.github.io/',
    github : "https://github.com/eiden0/eiden0.github.io",
    src : require('../assests/web_images/gameOfLife.png')
  },
  {
    type : 'Project',
    name : 'Online Mess Portal',
    description : 'Online Mess Portal For students',
    card_desc : "An online mess portal where students can register online and then select the menu from our cafeterias beforehand. This is an ongoing project.",
    p : 'An online mess portal where students can register online and then order food from our cafeterias. This project aims to minimize the food wastage and encourage students to not waste food. It also aims to bring a drastic change to current billing method of food for students in IIT Kharagpur',
    tech : ['HTML', 'CSS', 'Javascript', 'Django', 'Apache'],
    tags : ['HTML', 'Apache', 'Django']
  },
  {
    type : 'Project',
    name : 'Conway\'s Game of Life',
    description : 'An online visualization of Conway\'s Game of Life ',
    card_desc : "An online visualization of Conway's Game of Life. I was interested in this game as this showed that even a simple algorithm can have far-reaching results",
    p : 'The Game of Life is a cellular automaton devised by the British mathematician John Horton Conway in 1970. It is the best-known example of a cellular automaton. The "game" is actually a zero-player game, meaning that its evolution is determined by its initial state, needing no input from human players. One interacts with the Game of Life by creating an initial configuration and observing how it evolves.',
    tags : ['HTML', 'CSS', 'Javascript'],
    tech : ['Web-dev', 'HTML', 'CSS', 'JavaScript', 'p5.js'],
    link : 'https://eiden0.github.io/Conway-Game-of-life',
    github : "https://github.com/eiden0/Conway-Game-of-life",
    src : require('../assests/web_images/gameOfLife.png')
  },
]